export const countries = [
	{ name: 'United States (+1)', code: '+1' },
	{ name: 'United Kingdom (+44)', code: '+44' },
	{ name: 'Andorra (+376)', code: '+376' },
	{ name: 'Argentina (+54)', code: '+54' },
	{ name: 'Australia (+61)', code: '+61' },
	{ name: 'Austria (+43)', code: '+43' },
	{ name: 'Bahrain (+973)', code: '+973' },
	{ name: 'Bangladesh (+880)', code: '+880' },
	{ name: 'Belgium (+32)', code: '+32' },
	{ name: 'Brazil (+55)', code: '+55' },
	{ name: 'Brunei Darussalam (+673)', code: '+673' },
	{ name: 'Canada (+1)', code: '+1' },
	{ name: 'Chile (+56)', code: '+56' },
	{ name: 'China (+86)', code: '+86' },
	{ name: 'Colombia (+57)', code: '+57' },
	{ name: 'Denmark (+45)', code: '+45' },
	{ name: 'Egypt (+20)', code: '+20' },
	{ name: 'Finland (+358)', code: '+358' },
	{ name: 'France (+33)', code: '+33' },
	{ name: 'Germany (+49)', code: '+49' },
	{ name: 'Hong Kong (+852)', code: '+852' },
	{ name: 'Iceland (+354)', code: '+354' },
	{ name: 'India (+91)', code: '+91' },
	{ name: 'Indonesia (+62)', code: '+62' },
	{ name: 'Iran (+98)', code: '+98' },
	{ name: 'Iraq (+964)', code: '+964' },
	{ name: 'Ireland (+353)', code: '+353' },
	{ name: 'Israel (+972)', code: '+972' },
	{ name: 'Italy (+39)', code: '+39' },
	{ name: 'Japan (+81)', code: '+81' },
	{ name: 'Kenya (+254)', code: '+254' },
	{ name: 'Kuwait (+965)', code: '+965' },
	{ name: 'Luxembourg (+352)', code: '+352' },
	{ name: 'Macau (+853)', code: '+853' },
	{ name: 'Malaysia (+60)', code: '+60' },
	{ name: 'Mexico (+52)', code: '+52' },
	{ name: 'Morocco (+212)', code: '+212' },
	{ name: 'Netherlands (+31)', code: '+31' },
	{ name: 'New Zealand (+64)', code: '+64' },
	{ name: 'Nigeria (+234)', code: '+234' },
	{ name: 'Norway (+47)', code: '+47' },
	{ name: 'Oman (+968)', code: '+968' },
	{ name: 'Pakistan (+92)', code: '+92' },
	{ name: 'Peru (+51)', code: '+51' },
	{ name: 'Philippines (+63)', code: '+63' },
	{ name: 'Russia (+7)', code: '+7' },
	{ name: 'Saudi Arabia (+966)', code: '+966' },
	{ name: 'Singapore (+65)', code: '+65' },
	{ name: 'South Africa (+27)', code: '+27' },
	{ name: 'South Korea (+82)', code: '+82' },
	{ name: 'Spain (+34)', code: '+34' },
	{ name: 'Sweden (+46)', code: '+46' },
	{ name: 'Switzerland (+41)', code: '+41' },
	{ name: 'Suriname (+597)', code: '+597' },
	{ name: 'Thailand (+66)', code: '+66' },
	{ name: 'Tunisia (+216)', code: '+216' },
	{ name: 'Turkey (+90)', code: '+90' },
	{ name: 'United Arab Emirates (+971)', code: '+971' },
	{ name: 'United Kingdom (+44)', code: '+44' },
	{ name: 'United States (+1)', code: '+1' },
	{ name: 'Vietnam (+84)', code: '+84' },
	{ name: 'n/a', code: '' },
];

export const companyInfoPlaceholder = `John's Barbershop is a popular spot for men looking for a classic haircut experience. Located in the heart of downtown at 123 Alden Avenue in Berkeley, California, the shop boasts a team of highly skilled barbers who specialize in traditional cuts and shaves.

Summer Sale:
10% off all haircuts from June through August

Services:
- Haircuts: Starting at $30
- Beard Trims: Starting at $20
- Hot Towel Shaves: Starting at $50
- Neck Cleanups: Starting at $15 

Hours:
- Tuesday - Saturday: 9am to 6pm
- Sunday: 11am to 4pm
- Monday: Closed

Experience:
The barbers at John's Barbershop are known for their attention to detail and personalized service. Each barber has their own unique style and approach to cutting hair, but all share a passion for classic barbering techniques.

Address: 
123 Alden Avenue, Berkeley, California`;

export const qAndAPlaceholder = `Q: What services do you offer?
A: We offer haircuts, beard trims, hot towel shaves, and neck cleanups.

Q: I have a complaint
A: If you have a complaint, you can leave a message by saying "leave a message" and we will get back to you as soon as possible.

Q: Do you have any availability right now?
A: You can check for availability on our website.

Q: I want to cancel my appointment.
A: Please note our cancellation rescheduling policy: 24 hours for haircut services and 48 hours for hair coloring services. To cancel your appointment, use the link in your confirmation email or text message.`;

export const countriesWithFlag = [
	{ code: 'AD', name: 'Andorra', flag: '🇦🇩' },
	{ code: 'AE', name: 'United Arab Emirates', flag: '🇦🇪' },
	{ code: 'AF', name: 'Afghanistan', flag: '🇦🇫' },
	{ code: 'AG', name: 'Antigua and Barbuda', flag: '🇦🇬' },
	{ code: 'AI', name: 'Anguilla', flag: '🇦🇮' },
	{ code: 'AL', name: 'Albania', flag: '🇦🇱' },
	{ code: 'AM', name: 'Armenia', flag: '🇦🇲' },
	{ code: 'AO', name: 'Angola', flag: '🇦🇴' },
	{ code: 'AQ', name: 'Antarctica', flag: '🇦🇶' },
	{ code: 'AR', name: 'Argentina', flag: '🇦🇷' },
	{ code: 'AS', name: 'American Samoa', flag: '🇦🇸' },
	{ code: 'AT', name: 'Austria', flag: '🇦🇹' },
	{ code: 'AU', name: 'Australia', flag: '🇦🇺' },
	{ code: 'AW', name: 'Aruba', flag: '🇦🇼' },
	{ code: 'AX', name: 'Åland Islands', flag: '🇦🇽' },
	{ code: 'AZ', name: 'Azerbaijan', flag: '🇦🇿' },
	{ code: 'BA', name: 'Bosnia and Herzegovina', flag: '🇧🇦' },
	{ code: 'BB', name: 'Barbados', flag: '🇧🇧' },
	{ code: 'BD', name: 'Bangladesh', flag: '🇧🇩' },
	{ code: 'BE', name: 'Belgium', flag: '🇧🇪' },
	{ code: 'BF', name: 'Burkina Faso', flag: '🇧🇫' },
	{ code: 'BG', name: 'Bulgaria', flag: '🇧🇬' },
	{ code: 'BH', name: 'Bahrain', flag: '🇧🇭' },
	{ code: 'BI', name: 'Burundi', flag: '🇧🇮' },
	{ code: 'BJ', name: 'Benin', flag: '🇧🇯' },
	{ code: 'BL', name: 'Saint Barthélemy', flag: '🇧🇱' },
	{ code: 'BM', name: 'Bermuda', flag: '🇧🇲' },
	{ code: 'BN', name: 'Brunei', flag: '🇧🇳' },
	{ code: 'BO', name: 'Bolivia', flag: '🇧🇴' },
	{ code: 'BQ', name: 'Caribbean Netherlands', flag: '🇧🇶' },
	{ code: 'BR', name: 'Brazil', flag: '🇧🇷' },
	{ code: 'BS', name: 'Bahamas', flag: '🇧🇸' },
	{ code: 'BT', name: 'Bhutan', flag: '🇧🇹' },
	{ code: 'BV', name: 'Bouvet Island', flag: '🇧🇻' },
	{ code: 'BW', name: 'Botswana', flag: '🇧🇼' },
	{ code: 'BY', name: 'Belarus', flag: '🇧🇾' },
	{ code: 'BZ', name: 'Belize', flag: '🇧🇿' },
	{ code: 'CA', name: 'Canada', flag: '🇨🇦' },
	{ code: 'CC', name: 'Cocos Islands', flag: '🇨🇨' },
	{ code: 'CD', name: 'Democratic Republic of the Congo', flag: '🇨🇩' },
	{ code: 'CF', name: 'Central African Republic', flag: '🇨🇫' },
	{ code: 'CG', name: 'Republic of the Congo', flag: '🇨🇬' },
	{ code: 'CH', name: 'Switzerland', flag: '🇨🇭' },
	{ code: 'CI', name: "Côte d'Ivoire", flag: '🇨🇮' },
	{ code: 'CK', name: 'Cook Islands', flag: '🇨🇰' },
	{ code: 'CL', name: 'Chile', flag: '🇨🇱' },
	{ code: 'CM', name: 'Cameroon', flag: '🇨🇲' },
	{ code: 'CN', name: 'China', flag: '🇨🇳' },
	{ code: 'CO', name: 'Colombia', flag: '🇨🇴' },
	{ code: 'CR', name: 'Costa Rica', flag: '🇨🇷' },
	{ code: 'CU', name: 'Cuba', flag: '🇨🇺' },
	{ code: 'CV', name: 'Cape Verde', flag: '🇨🇻' },
	{ code: 'CW', name: 'Curaçao', flag: '🇨🇼' },
	{ code: 'CX', name: 'Christmas Island', flag: '🇨🇽' },
	{ code: 'CY', name: 'Cyprus', flag: '🇨🇾' },
	{ code: 'CZ', name: 'Czech Republic', flag: '🇨🇿' },
	{ code: 'DE', name: 'Germany', flag: '🇩🇪' },
	{ code: 'DJ', name: 'Djibouti', flag: '🇩🇯' },
	{ code: 'DK', name: 'Denmark', flag: '🇩🇰' },
	{ code: 'DM', name: 'Dominica', flag: '🇩🇲' },
	{ code: 'DO', name: 'Dominican Republic', flag: '🇩🇴' },
	{ code: 'DZ', name: 'Algeria', flag: '🇩🇿' },
	{ code: 'EC', name: 'Ecuador', flag: '🇪🇨' },
	{ code: 'EE', name: 'Estonia', flag: '🇪🇪' },
	{ code: 'EG', name: 'Egypt', flag: '🇪🇬' },
	{ code: 'EH', name: 'Western Sahara', flag: '🇪🇭' },
	{ code: 'ER', name: 'Eritrea', flag: '🇪🇷' },
	{ code: 'ES', name: 'Spain', flag: '🇪🇸' },
	{ code: 'ET', name: 'Ethiopia', flag: '🇪🇹' },
	{ code: 'FI', name: 'Finland', flag: '🇫🇮' },
	{ code: 'FJ', name: 'Fiji', flag: '🇫🇯' },
	{ code: 'FK', name: 'Falkland Islands', flag: '🇫🇰' },
	{ code: 'FM', name: 'Micronesia', flag: '🇫🇲' },
	{ code: 'FO', name: 'Faroe Islands', flag: '🇫🇴' },
	{ code: 'FR', name: 'France', flag: '🇫🇷' },
	{ code: 'GA', name: 'Gabon', flag: '🇬🇦' },
	{ code: 'GB', name: 'United Kingdom', flag: '🇬🇧' },
	{ code: 'GD', name: 'Grenada', flag: '🇬🇩' },
	{ code: 'GE', name: 'Georgia', flag: '🇬🇪' },
	{ code: 'GF', name: 'French Guiana', flag: '🇬🇫' },
	{ code: 'GG', name: 'Guernsey', flag: '🇬🇬' },
	{ code: 'GH', name: 'Ghana', flag: '🇬🇭' },
	{ code: 'GI', name: 'Gibraltar', flag: '🇬🇮' },
	{ code: 'GL', name: 'Greenland', flag: '🇬🇱' },
	{ code: 'GM', name: 'Gambia', flag: '🇬🇲' },
	{ code: 'GN', name: 'Guinea', flag: '🇬🇳' },
	{ code: 'GP', name: 'Guadeloupe', flag: '🇬🇵' },
	{ code: 'GQ', name: 'Equatorial Guinea', flag: '🇬🇶' },
	{ code: 'GR', name: 'Greece', flag: '🇬🇷' },
	{ code: 'GS', name: 'South Georgia and the South Sandwich Islands', flag: '🇬🇸' },
	{ code: 'GT', name: 'Guatemala', flag: '🇬🇹' },
	{ code: 'GU', name: 'Guam', flag: '🇬🇺' },
	{ code: 'GW', name: 'Guinea-Bissau', flag: '🇬🇼' },
	{ code: 'GY', name: 'Guyana', flag: '🇬🇾' },
	{ code: 'HK', name: 'Hong Kong', flag: '🇭🇰' },
	{ code: 'HM', name: 'Heard Island and McDonald Islands', flag: '🇭🇲' },
	{ code: 'HN', name: 'Honduras', flag: '🇭🇳' },
	{ code: 'HR', name: 'Croatia', flag: '🇭🇷' },
	{ code: 'HT', name: 'Haiti', flag: '🇭🇹' },
	{ code: 'HU', name: 'Hungary', flag: '🇭🇺' },
	{ code: 'ID', name: 'Indonesia', flag: '🇮🇩' },
	{ code: 'IE', name: 'Ireland', flag: '🇮🇪' },
	{ code: 'IL', name: 'Israel', flag: '🇮🇱' },
	{ code: 'IM', name: 'Isle of Man', flag: '🇮🇲' },
	{ code: 'IN', name: 'India', flag: '🇮🇳' },
	{ code: 'IO', name: 'British Indian Ocean Territory', flag: '🇮🇴' },
	{ code: 'IQ', name: 'Iraq', flag: '🇮🇶' },
	{ code: 'IR', name: 'Iran', flag: '🇮🇷' },
	{ code: 'IS', name: 'Iceland', flag: '🇮🇸' },
	{ code: 'IT', name: 'Italy', flag: '🇮🇹' },
	{ code: 'JE', name: 'Jersey', flag: '🇯🇪' },
	{ code: 'JM', name: 'Jamaica', flag: '🇯🇲' },
	{ code: 'JO', name: 'Jordan', flag: '🇯🇴' },
	{ code: 'JP', name: 'Japan', flag: '🇯🇵' },
	{ code: 'KE', name: 'Kenya', flag: '🇰🇪' },
	{ code: 'KG', name: 'Kyrgyzstan', flag: '🇰🇬' },
	{ code: 'KH', name: 'Cambodia', flag: '🇰🇭' },
	{ code: 'KI', name: 'Kiribati', flag: '🇰🇮' },
	{ code: 'KM', name: 'Comoros', flag: '🇰🇲' },
	{ code: 'KN', name: 'Saint Kitts and Nevis', flag: '🇰🇳' },
	{ code: 'KP', name: 'North Korea', flag: '🇰🇵' },
	{ code: 'KR', name: 'South Korea', flag: '🇰🇷' },
	{ code: 'KW', name: 'Kuwait', flag: '🇰🇼' },
	{ code: 'KY', name: 'Cayman Islands', flag: '🇰🇾' },
	{ code: 'KZ', name: 'Kazakhstan', flag: '🇰🇿' },
	{ code: 'LA', name: 'Laos', flag: '🇱🇦' },
	{ code: 'LB', name: 'Lebanon', flag: '🇱🇧' },
	{ code: 'LC', name: 'Saint Lucia', flag: '🇱🇨' },
	{ code: 'LI', name: 'Liechtenstein', flag: '🇱🇮' },
	{ code: 'LK', name: 'Sri Lanka', flag: '🇱🇰' },
	{ code: 'LR', name: 'Liberia', flag: '🇱🇷' },
	{ code: 'LS', name: 'Lesotho', flag: '🇱🇸' },
	{ code: 'LT', name: 'Lithuania', flag: '🇱🇹' },
	{ code: 'LU', name: 'Luxembourg', flag: '🇱🇺' },
	{ code: 'LV', name: 'Latvia', flag: '🇱🇻' },
	{ code: 'LY', name: 'Libya', flag: '🇱🇾' },
	{ code: 'MA', name: 'Morocco', flag: '🇲🇦' },
	{ code: 'MC', name: 'Monaco', flag: '🇲🇨' },
	{ code: 'MD', name: 'Moldova', flag: '🇲🇩' },
	{ code: 'ME', name: 'Montenegro', flag: '🇲🇪' },
	{ code: 'MF', name: 'Saint Martin', flag: '🇲🇫' },
	{ code: 'MG', name: 'Madagascar', flag: '🇲🇬' },
	{ code: 'MH', name: 'Marshall Islands', flag: '🇲🇭' },
	{ code: 'MK', name: 'North Macedonia', flag: '🇲🇰' },
	{ code: 'ML', name: 'Mali', flag: '🇲🇱' },
	{ code: 'MM', name: 'Myanmar', flag: '🇲🇲' },
	{ code: 'MN', name: 'Mongolia', flag: '🇲🇳' },
	{ code: 'MO', name: 'Macau', flag: '🇲🇴' },
	{ code: 'MP', name: 'Northern Mariana Islands', flag: '🇲🇵' },
	{ code: 'MQ', name: 'Martinique', flag: '🇲🇶' },
	{ code: 'MR', name: 'Mauritania', flag: '🇲🇷' },
	{ code: 'MS', name: 'Montserrat', flag: '🇲🇸' },
	{ code: 'MT', name: 'Malta', flag: '🇲🇹' },
	{ code: 'MU', name: 'Mauritius', flag: '🇲🇺' },
	{ code: 'MV', name: 'Maldives', flag: '🇲🇻' },
	{ code: 'MW', name: 'Malawi', flag: '🇲🇼' },
	{ code: 'MX', name: 'Mexico', flag: '🇲🇽' },
	{ code: 'MY', name: 'Malaysia', flag: '🇲🇾' },
	{ code: 'MZ', name: 'Mozambique', flag: '🇲🇿' },
	{ code: 'NA', name: 'Namibia', flag: '🇳🇦' },
	{ code: 'NC', name: 'New Caledonia', flag: '🇳🇨' },
	{ code: 'NE', name: 'Niger', flag: '🇳🇪' },
	{ code: 'NF', name: 'Norfolk Island', flag: '🇳🇫' },
	{ code: 'NG', name: 'Nigeria', flag: '🇳🇬' },
	{ code: 'NI', name: 'Nicaragua', flag: '🇳🇮' },
	{ code: 'NL', name: 'Netherlands', flag: '🇳🇱' },
	{ code: 'NO', name: 'Norway', flag: '🇳🇴' },
	{ code: 'NP', name: 'Nepal', flag: '🇳🇵' },
	{ code: 'NR', name: 'Nauru', flag: '🇳🇷' },
	{ code: 'NU', name: 'Niue', flag: '🇳🇺' },
	{ code: 'NZ', name: 'New Zealand', flag: '🇳🇿' },
	{ code: 'OM', name: 'Oman', flag: '🇴🇲' },
	{ code: 'PA', name: 'Panama', flag: '🇵🇦' },
	{ code: 'PE', name: 'Peru', flag: '🇵🇪' },
	{ code: 'PF', name: 'French Polynesia', flag: '🇵🇫' },
	{ code: 'PG', name: 'Papua New Guinea', flag: '🇵🇬' },
	{ code: 'PH', name: 'Philippines', flag: '🇵🇭' },
	{ code: 'PK', name: 'Pakistan', flag: '🇵🇰' },
	{ code: 'PL', name: 'Poland', flag: '🇵🇱' },
	{ code: 'PM', name: 'Saint Pierre and Miquelon', flag: '🇵🇲' },
	{ code: 'PN', name: 'Pitcairn Islands', flag: '🇵🇳' },
	{ code: 'PR', name: 'Puerto Rico', flag: '🇵🇷' },
	{ code: 'PS', name: 'Palestine', flag: '🇵🇸' },
	{ code: 'PT', name: 'Portugal', flag: '🇵🇹' },
	{ code: 'PW', name: 'Palau', flag: '🇵🇼' },
	{ code: 'PY', name: 'Paraguay', flag: '🇵🇾' },
	{ code: 'QA', name: 'Qatar', flag: '🇶🇦' },
	{ code: 'RE', name: 'Réunion', flag: '🇷🇪' },
	{ code: 'RO', name: 'Romania', flag: '🇷🇴' },
	{ code: 'RS', name: 'Serbia', flag: '🇷🇸' },
	{ code: 'RU', name: 'Russia', flag: '🇷🇺' },
	{ code: 'RW', name: 'Rwanda', flag: '🇷🇼' },
	{ code: 'SA', name: 'Saudi Arabia', flag: '🇸🇦' },
	{ code: 'SB', name: 'Solomon Islands', flag: '🇸🇧' },
	{ code: 'SC', name: 'Seychelles', flag: '🇸🇨' },
	{ code: 'SD', name: 'Sudan', flag: '🇸🇩' },
	{ code: 'SE', name: 'Sweden', flag: '🇸🇪' },
	{ code: 'SG', name: 'Singapore', flag: '🇸🇬' },
	{ code: 'SH', name: 'Saint Helena', flag: '🇸🇭' },
	{ code: 'SI', name: 'Slovenia', flag: '🇸🇮' },
	{ code: 'SJ', name: 'Svalbard and Jan Mayen', flag: '🇸🇯' },
	{ code: 'SK', name: 'Slovakia', flag: '🇸🇰' },
	{ code: 'SL', name: 'Sierra Leone', flag: '🇸🇱' },
	{ code: 'SM', name: 'San Marino', flag: '🇸🇲' },
	{ code: 'SN', name: 'Senegal', flag: '🇸🇳' },
	{ code: 'SO', name: 'Somalia', flag: '🇸🇴' },
	{ code: 'SR', name: 'Suriname', flag: '🇸🇷' },
	{ code: 'SS', name: 'South Sudan', flag: '🇸🇸' },
	{ code: 'ST', name: 'São Tomé and Príncipe', flag: '🇸🇹' },
	{ code: 'SV', name: 'El Salvador', flag: '🇸🇻' },
	{ code: 'SX', name: 'Sint Maarten', flag: '🇸🇽' },
	{ code: 'SY', name: 'Syria', flag: '🇸🇾' },
	{ code: 'SZ', name: 'Eswatini', flag: '🇸🇿' },
	{ code: 'TC', name: 'Turks and Caicos Islands', flag: '🇹🇨' },
	{ code: 'TD', name: 'Chad', flag: '🇹🇩' },
	{ code: 'TF', name: 'French Southern Territories', flag: '🇹🇫' },
	{ code: 'TG', name: 'Togo', flag: '🇹🇬' },
	{ code: 'TH', name: 'Thailand', flag: '🇹🇭' },
	{ code: 'TJ', name: 'Tajikistan', flag: '🇹🇯' },
	{ code: 'TK', name: 'Tokelau', flag: '🇹🇰' },
	{ code: 'TL', name: 'Timor-Leste', flag: '🇹🇱' },
	{ code: 'TM', name: 'Turkmenistan', flag: '🇹🇲' },
	{ code: 'TN', name: 'Tunisia', flag: '🇹🇳' },
	{ code: 'TO', name: 'Tonga', flag: '🇹🇴' },
	{ code: 'TR', name: 'Turkey', flag: '🇹🇷' },
	{ code: 'TT', name: 'Trinidad and Tobago', flag: '🇹🇹' },
	{ code: 'TV', name: 'Tuvalu', flag: '🇹🇻' },
	{ code: 'TW', name: 'Taiwan', flag: '🇹🇼' },
	{ code: 'TZ', name: 'Tanzania', flag: '🇹🇿' },
	{ code: 'UA', name: 'Ukraine', flag: '🇺🇦' },
	{ code: 'UG', name: 'Uganda', flag: '🇺🇬' },
	{ code: 'UM', name: 'U.S. Minor Outlying Islands', flag: '🇺🇲' },
	{ code: 'US', name: 'United States', flag: '🇺🇸' },
	{ code: 'UY', name: 'Uruguay', flag: '🇺🇾' },
	{ code: 'UZ', name: 'Uzbekistan', flag: '🇺🇿' },
	{ code: 'VA', name: 'Vatican City', flag: '🇻🇦' },
	{ code: 'VC', name: 'Saint Vincent and the Grenadines', flag: '🇻🇨' },
	{ code: 'VE', name: 'Venezuela', flag: '🇻🇪' },
	{ code: 'VG', name: 'British Virgin Islands', flag: '🇻🇬' },
	{ code: 'VI', name: 'U.S. Virgin Islands', flag: '🇻🇮' },
	{ code: 'VN', name: 'Vietnam', flag: '🇻🇳' },
	{ code: 'VU', name: 'Vanuatu', flag: '🇻🇺' },
	{ code: 'WF', name: 'Wallis and Futuna', flag: '🇼🇫' },
	{ code: 'WS', name: 'Samoa', flag: '🇼🇸' },
	{ code: 'XK', name: 'Kosovo', flag: '🇽🇰' },
	{ code: 'YE', name: 'Yemen', flag: '🇾🇪' },
	{ code: 'YT', name: 'Mayotte', flag: '🇾🇹' },
	{ code: 'ZA', name: 'South Africa', flag: '🇿🇦' },
	{ code: 'ZM', name: 'Zambia', flag: '🇿🇲' },
	{ code: 'ZW', name: 'Zimbabwe', flag: '🇿🇼' },
];
